import { DEAL_STAGE, DealStage } from 'models/DealRoom';
import { LISTING_STAGE, ListingStage } from 'models/Listing';
import { ColorVariants, COLOR_VARIANT } from 'models/Colors';

export const DEAL_STATUS_COLOR: Record<DealStage, ColorVariants> = {
  [DEAL_STAGE.SELLER_LEAD]: COLOR_VARIANT.GREY,
  [DEAL_STAGE.MANDATED]: COLOR_VARIANT.DARK_GREEN,
  [DEAL_STAGE.LIVE]: COLOR_VARIANT.GREEN,
  [DEAL_STAGE.UNDER_OFFER]: COLOR_VARIANT.ORANGE,
  [DEAL_STAGE.UNDER_CONTRACT]: COLOR_VARIANT.ORANGE,
  [DEAL_STAGE.SOLD]: COLOR_VARIANT.BLUE,
  [DEAL_STAGE.COMPLETE]: COLOR_VARIANT.BLUE,
  [DEAL_STAGE.LOST]: COLOR_VARIANT.RED,
  [DEAL_STAGE.ARCHIVED]: COLOR_VARIANT.GREY,
};

export const DEAL_STATUS_LABEL: Record<DealStage, string> = {
  [DEAL_STAGE.SELLER_LEAD]: 'sellerLead',
  [DEAL_STAGE.MANDATED]: 'mandated',
  [DEAL_STAGE.LIVE]: 'live',
  [DEAL_STAGE.UNDER_OFFER]: 'underOffer',
  [DEAL_STAGE.UNDER_CONTRACT]: 'contract',
  [DEAL_STAGE.SOLD]: 'sold',
  [DEAL_STAGE.COMPLETE]: 'complete',
  [DEAL_STAGE.LOST]: 'lost',
  [DEAL_STAGE.ARCHIVED]: 'archived',
};

export const DEAL_STATUS_DESCRIPTION: Record<DealStage, string> = {
  [DEAL_STAGE.SELLER_LEAD]: 'sellerLeadDescription',
  [DEAL_STAGE.MANDATED]: 'mandatedDescription',
  [DEAL_STAGE.LIVE]: 'liveDescription',
  [DEAL_STAGE.UNDER_OFFER]: 'underOfferDescription',
  [DEAL_STAGE.UNDER_CONTRACT]: 'contractDescription',
  [DEAL_STAGE.SOLD]: 'soldDescription',
  [DEAL_STAGE.COMPLETE]: 'completeDescription',
  [DEAL_STAGE.LOST]: 'lostDescription',
  [DEAL_STAGE.ARCHIVED]: 'archivedDescription',
};

export const LISTING_STATUS_COLOR: Record<ListingStage, ColorVariants> = {
  [LISTING_STAGE.NO_LISTING]: COLOR_VARIANT.GREY,
  [LISTING_STAGE.DRAFT]: COLOR_VARIANT.TRANSPARENT,
  [LISTING_STAGE.PUBLIC]: COLOR_VARIANT.GREEN,
  [LISTING_STAGE.PRIVATE]: COLOR_VARIANT.RED,
  [LISTING_STAGE.PAUSED]: COLOR_VARIANT.RED,
  [LISTING_STAGE.ENDED]: COLOR_VARIANT.BLUE,
};

export const LISTING_STATUS_LABEL: Record<ListingStage, string> = {
  [LISTING_STAGE.NO_LISTING]: 'noListing',
  [LISTING_STAGE.DRAFT]: 'draft',
  [LISTING_STAGE.PUBLIC]: 'public',
  [LISTING_STAGE.PRIVATE]: 'private',
  [LISTING_STAGE.PAUSED]: 'paused',
  [LISTING_STAGE.ENDED]: 'ended',
};
